import {
  createContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  Alert,
  Button,
  CardHeader,
  Col,
  Input,
  InputGroup,
  Modal,
  ModalBody,
  Row,
} from 'reactstrap';

import {
  Box,
  CircularProgress,
  Tab,
  Tabs,
  Tooltip,
  useMediaQuery,
} from '@material-ui/core';
import { useQuery } from 'react-query';

import api from 'services/api';
import PropostaModel from 'models/Proposta';
import { PropostaVersao } from 'models/PropostaVersao';
import { PropostaConfiguracao } from 'models/PropostaConfiguracao';
import { PropostaStatus } from 'models/PropostaStatus';

import UserSmallHeader from 'components/Headers/UserSmallHeader';
import TabPanel from 'components/TabPanel';
import AppBar from 'components/AppBar';
import { FaHistory, FaPrint, FaUser } from 'react-icons/fa';

import ModalLog from 'components/ModalLog';
import { PropostaMeioPagamento } from 'models/PropostaMeioPagamento';
import { useAuth } from 'hooks/auth';
import ValidarAcessoPrograma from 'models/ValidarAcessoPrograma';
import { ProdutoProposta } from 'models/ProdutoProposta';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';
import { addDays } from 'date-fns';
import { PropostaLocalObra } from 'models/PropostaLocalObra';
import ModalPessoaGrupo from 'views/components/ModalPessoaGrupo';
import Materiais, { MateriaisContext } from './components/Materiais';
import LocalObra from './components/Obra/LocalObra';
import MaoDeObra from './components/Obra/MaoDeObra';
import ValoresPorConfiguracao from './components/Obra/ValoresPorConfiguracao';
import Parcelas from './components/Parcelas';
import Resultados from './components/Resultados';
import Aprovacao from './components/Aprovacao';
import LogsCalculoServico from './components/LogsCalculoServico';
import Observacao from './components/Observacao';
import ValoresAprovacao from './components/ValoresAprovacao';
import ModalValoresAprovacao from './components/ModalValoresAprovacao';
import MatrizResponsabilidade from './components/MatrizResponsabilidade';
import PosicaoGeografica from './components/Obra/PosicaoGeografica';
import ReportTemplate from '../AtaProposta/ReportTemplate';
import Compras from './components/Compras';
import Resumo from './components/Resumo';
import Precificacao from './components/Precificacao';
import AvalistaObra from './components/Obra/AvalistaObra';

interface LocationState {
  proposta: PropostaModel;
  propostaVersao: PropostaVersao;
  acessarAprovacao: boolean | false;
}

interface PropostaContext {
  propostaVersao: PropostaVersao;
  propostaLocalObra: PropostaLocalObra;
  setPropostaVersao: (propostaVersao: PropostaVersao) => void;
  setPropostaLocalObra: (propostaLocalObra: PropostaLocalObra) => void;
  permiteModificacao: boolean;
  formatoMaoDeObra: string;
  setFormatoMaoDeObra: (valor: string) => void;
  condicaoFrete: string;
  setCondicaoFrete: (valor: string) => void;
  carregaPropostaVersao: () => void;
  propostaConfiguracoes: PropostaConfiguracao[];
  setPropostaConfiguracoes: (
    propostaConfiguracoes: PropostaConfiguracao[],
  ) => void;
  meioPagamentos: PropostaMeioPagamento[];
  meioPagamentoIdSelecionado: number | undefined;
  setMeioPagamentoIdSelecionado: (value: number | undefined) => void;
  acessoLimitado: boolean;
  isObraExterior: boolean;
  setIsObraExterior: (value: boolean) => void;
  setTriggerMaterialCheck: (value: boolean) => void;
  isMaterialValid: boolean;
  atualizarTelaProposta: (value: boolean) => void;
  isIsentoComissao?: boolean;
  setIsIsentoComissao?: (value: boolean) => void;
  bloquearLocal: boolean;
  setBloquearLocal: (value: boolean) => void;
  baixarAta: boolean;
  setBaixarAta: (value: boolean) => void;
  configuracaoId: number | undefined;
  setConfiguracaoId: (value: number | undefined) => void;
  setPrecosDesatualizados: (value: boolean) => void;
  regramentoProposta: boolean | null;
}
const ID_STATUS_EM_APROVACAO = 6;

const ESCOPO_CONCLUIDO_ID = 9;
const ESCOPO_CONCLUIDO_ORDEM = 3;

export const PropostaContext = createContext({} as PropostaContext);

const STATUS_APROVADO_ID = 3;
export default function Proposta(): JSX.Element {
  const history = useHistory();
  const location = useLocation<LocationState>();
  const { usuario } = useAuth();
  const [acessoLimitado, setAcessoLimitado] = useState(true);
  const [isObraExterior, setIsObraExterior] = useState(false);
  const [hierarquiaDomSGE, setHierarquiaDomSGE] = useState<any>({});
  const [acessoLimitadoAta, setAcessoLimitadoAta] = useState(
    {} as ValidarAcessoPrograma,
  );

  const {
    proposta,
    propostaVersao: propostaVersaoLocation,
    acessarAprovacao,
  } = location.state;
  const [propostaVersao, setPropostaVersao] = useState<PropostaVersao>(
    propostaVersaoLocation,
  );
  const [propostaLocalObra, setPropostaLocalObra] = useState(
    {} as PropostaLocalObra,
  );
  const [propostaConfiguracoes, setPropostaConfiguracoes] = useState<
    PropostaConfiguracao[]
  >([]);
  const [carregandoPropostaConfiguracoes, setCarregandoPropostaConfiguracoes] =
    useState(false);
  const [currentTab, setCurrentTab] = useState(0);
  const [maoDeObraAtualizada, setMaoDeObraAtualizada] = useState(false);
  const [statusIdAtual, setStatusIdAtual] = useState<number>(1);
  const [listaStatus, setListaStatus] = useState<PropostaStatus[]>([]);
  const [atualizandoStatus, setAtualizandoStatus] = useState(false);
  const [modalStatusLogVisivel, setModalStatusLogVisivel] = useState(false);
  const [contemAbaAprovacao, setContemAbaAprovacao] = useState(false);
  const [formatoMaoDeObra, setFormatoMaoDeObra] = useState('');
  const [condicaoFrete, setCondicaoFrete] = useState(
    propostaVersao.condicaoFrete || '',
  );
  const [meioPagamentos, setMeioPagamentos] = useState<PropostaMeioPagamento[]>(
    [],
  );
  const [listaOrcamentosProposta, setListaOrcamentosProposta] = useState<
    number[]
  >([]);
  const [tipoGerar, setTipoGerar] = useState('GNF');
  const [regramentoProposta, setRegramentoProposta] = useState(null);

  // Disparar processo validação material
  const [isMaterialValid, setIsMaterialValid] = useState(false);
  const [triggerMaterialCheck, setTriggerMaterialCheck] = useState(true);
  const [propostaComValor, setPropostaComValor] = useState(false);
  const [liberaImpressao, setLiberaImpressao] = useState(false);
  const [baixarAta, setBaixarAta] = useState(false);

  const [loadingProposta, setLoadingProposta] = useState(false);
  const [meioPagamentoIdSelecionado, setMeioPagamentoIdSelecionado] =
    useState<number>();
  const permiteModificacao = propostaVersao.status.indicPermiteModificar;
  const [acessoProgramaAprovacao, setAcessoProgramaAprovacao] = useState(
    {} as { podeAcessar: boolean },
  );
  const [produtoProposta, setProdutoProposta] = useState({} as ProdutoProposta);
  const [acessoLimitadoValorMaoObra, setAcessoLimitadoValorMaoObra] = useState(
    {} as ValidarAcessoPrograma,
  );
  const [sessaoId, setSessaoId] = useState('');
  const [configuracaoId, setConfiguracaoId] = useState<number>();
  const [modalCalculoLogVisivel, setModalCalculoLogVisivel] = useState(false);

  const [bloquearTudo, setBloquearTudo] = useState(false);
  const [configuracoesSemAcesso, setConfiguracoesSemAcesso] =
    useState<number[]>();
  const [isIsentoComissao, setIsIsentoComissao] = useState(false);
  const [bloquearLocal, setBloquearLocal] = useState(false);
  const [dataValidadeFormatada, setDataValidadeFormatada] = useState(
    new Date(),
  );
  const [dadosBasicosCarregados, setDadosBasicosCarregados] = useState(false);
  const [liberaEtapa, setLiberaEtapa] = useState(true);
  const [liberaAposMaterial, setLiberaAposMaterial] = useState(true);
  const [percentualServicos, setPercentualServicos] = useState<number>();
  const [percentualServicosCarregado, setPercentualServicosCarregado] =
    useState(false);
  const [bloquearProposta, setBloquearProposta] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalConfirmacaoDisparada, setModalConfirmacaoDisparada] =
    useState(false);
  const [precosDesatualizados, setPrecosDesatualizados] = useState(false);

  const [acessoProgramaAnalisador, setAcessoProgramaAnalisador] = useState(
    {} as ValidarAcessoPrograma,
  );

  const [mostrarBotaoMudarPessoa, setMostrarBotaoMudarPessoa] = useState(
    {} as ValidarAcessoPrograma,
  );

  const [modalManterPessoaGrupo, setModalManterPessoaGrupo] = useState(false);

  const [propostaCliente, setPropostaCliente] = useState<PropostaModel>(
    {} as PropostaModel,
  );

  const [gnfBloqueado, setGnfBloqueado] = useState(false);
  const [gnfBloqueadoMotivo, setGnfBloqueadoMotivo] = useState('');

  const [
    acessoProgramaModificarStatusAprovada,
    setAcessoProgramaModificarStatusAprovada,
  ] = useState({} as ValidarAcessoPrograma);

  const [isRegramentoGeral, setIsRegramentoGeral] = useState(true);

  const isSmallScreen = useMediaQuery('(max-width:1400px)');
  const isSmartphoneScreen = useMediaQuery('(max-width:700px)');

  const { data: queryMeioPagamento } = useQuery(
    `proposta-meio-pagamento`,
    async () => {
      async function getMeioPagamentos(): Promise<PropostaMeioPagamento[]> {
        const response = await api.get('/proposta/meio-pagamento');
        return response.data;
      }

      const dataMeioPagamento = await getMeioPagamentos();
      return dataMeioPagamento;
    },
    { staleTime: 1000 * 60 * 10 },
  );

  useEffect(() => {
    sessionStorage.setItem('TelaConfig', '');
  }, []);

  useEffect(() => {
    if (!dadosBasicosCarregados) {
      Swal.fire({
        icon: 'info',
        text: `Buscando dados básicos da proposta`,
        allowOutsideClick: false,
        showConfirmButton: false,
        showCancelButton: false,
      });
    } else {
      Swal.close();
    }
  }, [dadosBasicosCarregados]);

  useEffect(() => {
    if (
      propostaVersao &&
      propostaLocalObra &&
      percentualServicosCarregado === true &&
      bloquearProposta !== undefined
    ) {
      setDadosBasicosCarregados(true);
    }
  }, [
    propostaVersao,
    propostaLocalObra,
    percentualServicosCarregado,
    bloquearProposta,
  ]);

  async function carregaDadosPercentuais() {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/precificacao`,
    );

    const precificacao = response.data?.[0];

    setPercentualServicos(precificacao.percentualServicos);
    setPercentualServicosCarregado(true);
  }

  async function carregarProdutosProposta() {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/produtos`,
    );

    const produtos = response.data;

    setIsRegramentoGeral(!produtos[0].regramentoProposta);
  }

  async function carregaProdutoGnf() {
    const produtognf = await api.get(
      `/proposta-negocio/${propostaVersao.id}/valida-produto-gnf`,
      {},
    );

    if (produtognf.data.geraPS) setTipoGerar('PS');
    setRegramentoProposta(produtognf.data.regramento);

    setPercentualServicosCarregado(true);
  }

  async function confirmarAtualizacaoValores() {
    Swal.fire({
      icon: 'info',
      text: `Atualizando informações da proposta`,
      allowOutsideClick: false,
      showConfirmButton: false,
      showCancelButton: false,
    });

    try {
      await api.post(`/proposta/versao/${propostaVersao.id}/reprocessar`);

      Swal.close();
    } catch (error: any) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: error?.response?.data?.message,
      });
    } finally {
      // setPropostaConfiguracoes([]);
      setPrecosDesatualizados(false);
      // await salvarValores();
      // await buscarConfiguracoes();
    }
  }

  useEffect(() => {
    async function carregarListaPreco() {
      const response = await api.get(
        `/proposta/versao/${propostaVersao.id}/validar-precos`,
      );

      setPrecosDesatualizados(response.data.desatualizado ?? false);
    }
    carregarListaPreco();

    carregarProdutosProposta();
  }, []);

  useEffect(() => {
    if (
      dadosBasicosCarregados &&
      !gnfBloqueado &&
      precosDesatualizados === true
    ) {
      confirmarAtualizacaoValores();
    }
  }, [precosDesatualizados, dadosBasicosCarregados]);

  useEffect(() => {
    if (queryMeioPagamento) {
      setMeioPagamentos(queryMeioPagamento);
    }
  }, [queryMeioPagamento]);

  async function carregaConfiguracoes() {
    try {
      setCarregandoPropostaConfiguracoes(true);
      const response = await api.get(`/proposta/${proposta.id}`);
      const propostaCompleta = response.data as PropostaModel;
      const configuracoes = propostaCompleta.PropostaVersao.find(
        propostaVers => propostaVers.versao === propostaVersao.versao,
      )?.PropostaConfiguracao;
      setPropostaCliente(propostaCompleta);

      setIsIsentoComissao(propostaCompleta.usuario.isIsentoComissao);
      if (configuracoes) {
        // setPropostaConfiguracoes(configuracoes);
        setListaOrcamentosProposta(
          configuracoes.map(config => config.orcamentoId),
        );
        let sessao = '';
        let configId = 0;
        configuracoes.map(item => {
          sessao = String(item.fichaTecnica?.sessaoId);
          configId = item.orcamentoId;
          return <></>;
        });
        // Esses dois aqui não fazem sentido.
        setSessaoId(sessao);
        setConfiguracaoId(configId);
      }
    } finally {
      setCarregandoPropostaConfiguracoes(false);
      setMaoDeObraAtualizada(false);
    }
  }

  const { data: queryListaStatus } = useQuery(
    `proposta-status`,
    async () => {
      async function getStatus(): Promise<PropostaStatus[]> {
        const response = await api.get('/proposta/status');
        return response.data;
      }

      const dataStatus = await getStatus();
      return dataStatus;
    },
    { staleTime: 1000 * 60 * 10 },
  );

  const { data: queryConfiguracoes } = useQuery(
    `proposta-configuracoes`,
    async () => {
      async function getConfiguracoes(): Promise<PropostaConfiguracao[]> {
        const response = await api.get(
          `/proposta/versao/${propostaVersao.id}/configuracoes`,
        );
        return response.data;
      }

      const dataStatus = await getConfiguracoes();
      return dataStatus;
    },
    { staleTime: 1000 * 60 * 10 },
  );

  async function carregaPropostaVersao() {
    try {
      setLoadingProposta(true);
      const response = await api.get(
        `/proposta/versao/${propostaVersaoLocation.id}`,
      );

      if (response.data.gnfBloqueado === true) {
        setGnfBloqueado(true);
        setGnfBloqueadoMotivo(response.data.gnfBloqueadoMotivo ?? '');
      }

      const preValorFinal = response.data?.valorFinal ?? 0;

      setPropostaComValor(preValorFinal && preValorFinal > 0);

      setPropostaVersao(response.data);
    } finally {
      setLoadingProposta(false);
    }
  }

  async function getPropostaBloqueada() {
    const response = await api.get(
      `/proposta/versao/${propostaVersaoLocation.id}/bloqueio`,
    );

    const varBloquearProposta = response.data?.bloquear ?? false;
    if (varBloquearProposta === true) setBloquearProposta(true);
  }

  async function carregaLocalObra() {
    if (propostaVersao.id) {
      const response = await api.get(
        `/proposta/${propostaVersao.id}/local-obra`,
      );
      setPropostaLocalObra(response.data);
    }
  }

  async function atualizarTelaProposta(mostrarAbaAprovacao: boolean) {
    try {
      if (acessoProgramaAprovacao) {
        await carregaPropostaVersao();
        setCurrentTab(0); // define a primeira aba

        // Caso tenha que mostrar, mostra apenas se tiver acesso
        if (mostrarAbaAprovacao === true)
          setContemAbaAprovacao(acessoProgramaAprovacao.podeAcessar === true);
        else setContemAbaAprovacao(false); // desativa a aba aprovação
      }
    } finally {
      setLoadingProposta(false);
      carregaLocalObra();
    }
  }

  async function getAcessoLimitadoPrograma() {
    const response = await api.get('/acesso-programa/acesso-limitado', {
      params: {
        programaId: 28,
        usuarioId: usuario.id,
      },
    });
    setAcessoLimitado(response.data);

    const responseAnalisador = await api.get(
      '/acesso-programa/acesso-programa',
      {
        params: {
          programaId: 84,
          usuarioId: usuario.id,
        },
      },
    );
    setAcessoProgramaAnalisador(responseAnalisador.data);

    const response2 = await api.get(
      `/proposta/versao/${propostaVersao.id}/aprovacao`,
      {},
    );

    setAcessoProgramaAprovacao({
      podeAcessar: response2.data.podeAcessar ?? false,
    });

    const response3 = await api.get('/acesso-programa/acesso-programa', {
      params: {
        programaId: 59,
        usuarioId: usuario.id,
      },
    });
    setAcessoLimitadoValorMaoObra(response3.data);

    const response4 = await api.get('/acesso-programa/acesso-programa', {
      params: {
        programaId: 68,
        usuarioId: usuario.id,
      },
    });
    setAcessoProgramaModificarStatusAprovada(response4.data);

    const response5 = await api.get('/acesso-programa/acesso-programa', {
      params: {
        programaId: 87,
      },
    });

    setMostrarBotaoMudarPessoa(response5.data);
    const responseAta = await api.get('/acesso-programa/acesso-programa', {
      params: {
        programaId: 86,
        usuarioId: usuario.id,
      },
    });
    setAcessoLimitadoAta(responseAta.data);
  }

  async function getAcessoProposta() {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/acesso`,
    );

    const acessoProposta = response.data as {
      acesso: boolean;
      configuracoes: number[];
    };

    if (acessoProposta.acesso === false) {
      setBloquearTudo(true);
      setConfiguracoesSemAcesso(acessoProposta.configuracoes);
    }
  }

  async function getProdutoProposta() {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/produto`,
    );

    setProdutoProposta(response.data);
  }

  async function carregarParametros() {
    const response = await api.get('/parametros');
    let diasVigencia;
    if (response.data) {
      diasVigencia = response.data.validadeProposta;
      const dataValidade = addDays(new Date(), diasVigencia);
      setDataValidadeFormatada(dataValidade);
    }
  }

  async function getHierarquia() {
    const response = await api.get(
      `/proposta/hierarquia/${proposta.usuario.pessoaDomSGE}`,
    );

    setHierarquiaDomSGE(response.data);
  }

  useEffect(() => {
    carregarParametros();
    getHierarquia();
    carregaProdutoGnf();
  }, []);

  useEffect(() => {
    carregaLocalObra();
  }, []);

  useEffect(() => {
    getAcessoLimitadoPrograma();
    getAcessoProposta();
  }, []);

  useEffect(() => {
    getProdutoProposta();
  }, []);

  // carrega dados básicos
  useEffect(() => {
    setDadosBasicosCarregados(false);
    carregaPropostaVersao();
    getPropostaBloqueada();
    carregaLocalObra();
    carregaDadosPercentuais();
  }, [propostaVersaoLocation]);

  useEffect(() => {
    if (propostaVersao) {
      setCondicaoFrete(propostaVersao.condicaoFrete || '');
    }
  }, [propostaVersao]);

  useEffect(() => {
    if (queryListaStatus) {
      setListaStatus(queryListaStatus);
    }
  }, [queryListaStatus]);

  useEffect(() => {
    carregaConfiguracoes();
    setStatusIdAtual(propostaVersao.status.id);
  }, [proposta, propostaVersao]);

  useEffect(() => {
    if (proposta.PropostaVersao.length > 1 || propostaVersao.versao > 1) {
      setBloquearLocal(true);
    } else {
      setBloquearLocal(false);
    }
  }, [proposta, propostaVersao]);

  useEffect(() => {
    if (maoDeObraAtualizada) {
      carregaConfiguracoes();
    }
  }, [maoDeObraAtualizada]);

  async function verificarImprimirProposta() {
    const responseBloqueioImpressao = await api.get(
      `/proposta/versao/${propostaVersao.id}/validar-impressao-proposta`,
    );

    if (responseBloqueioImpressao) {
      const imprimir = Boolean(
        responseBloqueioImpressao.data?.permiteImprimirProposta ?? false,
      );
      setLiberaImpressao(imprimir);
    } else {
      setLiberaImpressao(false);
    }
  }

  useEffect(() => {
    if (propostaVersao) {
      verificarImprimirProposta();
    }
  }, [propostaVersao]);

  useEffect(() => {
    if (triggerMaterialCheck === false && proposta && propostaVersao) {
      const meioPagamentoSelecionado = propostaVersao.meioPagamento?.id ?? 0;
      const formaPagamento = propostaVersao.PropostaVersaoParcelas;
      const materiaisValor = propostaVersao.valorFinal;
      const propostaLocal = propostaVersao.propostaId;
      let somaPercentual = 0;

      if (formaPagamento) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < formaPagamento.length; i++) {
          somaPercentual += formaPagamento[i].percentual ?? 0;
        }
        /*
      // Comentei essa forma usada com reduce, para usar caso o uso do "for" não funcione mais pra frente
      const somaPercentual = formaPagamento.reduce(function (
        totalizador,
        object,
      ) {
        return totalizador + (object.percentual ?? 0);
      },
      0);
      */
      }

      const isExterno = propostaLocalObra?.exterior ?? false;

      if (bloquearProposta || gnfBloqueado) {
        setLiberaEtapa(false);
      } else if (
        isExterno ||
        (propostaLocalObra?.inscricaoEstadual &&
          propostaLocalObra?.inscricaoEstadual !== '' &&
          propostaLocalObra?.inscricaoEstadual !== null &&
          propostaLocalObra?.inscricaoEstadual !== undefined &&
          propostaVersao.condicaoFrete &&
          propostaVersao.condicaoFrete !== '' &&
          propostaVersao.condicaoFrete !== null &&
          propostaVersao.condicaoFrete !== undefined)
      ) {
        setLiberaEtapa(true);
      } else {
        setLiberaEtapa(false);
      }

      if (
        isExterno ||
        (propostaVersao.valorFrete &&
          propostaVersao.valorFrete !== null &&
          propostaVersao.valorFrete !== undefined &&
          percentualServicos &&
          percentualServicos !== null &&
          percentualServicos !== undefined)
      ) {
        setLiberaAposMaterial(true);
      } else {
        setLiberaAposMaterial(false);
      }
      // Local vou deixar liberado isso
      setLiberaAposMaterial(true);
    }
  }, [propostaVersao, triggerMaterialCheck, proposta, propostaLocalObra]);

  async function atualizaStatus(id: number): Promise<void> {
    try {
      setAtualizandoStatus(true);
      await api.put(`/proposta/versao/${propostaVersao.id}/status/${id}`, {
        dataValidade: dataValidadeFormatada,
        modalConfirmacao: modalConfirmacaoDisparada ? 'S' : 'N',
      });
    } finally {
      setAtualizandoStatus(false);
      await carregaPropostaVersao();
    }
  }

  async function dispararMensagemMudancaStatus(novoStatusId: number) {
    if (novoStatusId !== 3)
      return {
        prosseguir: true,
        statusUsar: novoStatusId,
      };

    // Vai disparar uma modal de confirmação
    const mudancaStatus = await Swal.fire({
      title: `Atenção`,
      html: `<div style='text-align: justify!important; text-justify: inter-word;'>
      Ao mudar o status para Aprovado, será disparado processo de Aprovação, onde a proposta será analisada e aprovada ou reprovada. O status da proposta ficará como 'Em Aprovação final'. Deseja prosseguir?</div>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim, prosseguir`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    });

    return {
      prosseguir: mudancaStatus.isConfirmed,
      statusUsar: novoStatusId,
    };
  }

  async function handleChangeStatusAtual(novoStatusId: number) {
    // Vai disparar uma modal de confirmação
    /*
    try {
      // eslint-disable-next-line no-alert
      ReportTemplate();
    } catch {
      // eslint-disable-next-line no-alert
      alert('Erro');
    }
    */
    const retorno = await dispararMensagemMudancaStatus(novoStatusId);

    if (retorno.prosseguir) {
      if (retorno.statusUsar === STATUS_APROVADO_ID) {
        const responseBloqueioStatus = await api.get(
          `/proposta/versao/${propostaVersao.id}/status/${retorno.statusUsar}`,
        );

        const bloqueioStatus = responseBloqueioStatus.data as {
          bloquear: boolean;
          motivo?: string;
        };

        if (
          bloqueioStatus.bloquear === true &&
          bloqueioStatus.motivo === 'MATRIZ_DATAS_NAO_PREENCHIDAS'
        ) {
          const valor = await Swal.fire({
            title: `Atenção`,
            html: `<div style='text-align: justify!important; text-justify: inter-word;'>
            Algumas datas da matriz de responsabilidade não foram preenchidas.
            <br />Ao prosseguir, a proposta ficará bloqueada e nenhuma modificação futura será possível. Deseja prosseguir?</div>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `Sim, prosseguir`,
            confirmButtonColor: '#d33',
            cancelButtonText: `Não`,
          });

          if (valor.isConfirmed) {
            setModalConfirmacaoDisparada(true);
            setIsModalOpen(!isModalOpen);
          }
        } else {
          setModalConfirmacaoDisparada(false);
          setIsModalOpen(!isModalOpen);
        }
      } else {
        await atualizaStatus(retorno.statusUsar);
        setModalConfirmacaoDisparada(false);
        setStatusIdAtual(retorno.statusUsar);
      }
      setBaixarAta(true);
    }
  }

  function handleImprimeProposta() {
    if (loadingProposta || !liberaImpressao) {
      return;
    }

    history.push({
      pathname: '/admin/proposta-impressao-novo',
      state: { proposta, propostaVersao, produtoProposta },
    });

    /* if (produtoProposta.isIrrigacao)
      history.push({
        pathname: '/admin/proposta-impressao-novo',
        state: { proposta, propostaVersao, produtoProposta },
      });
    else
      history.push({
        pathname: '/admin/proposta-impressao-geral',
        state: { proposta, propostaVersao, produtoProposta },
      }); */
  }

  function handleGerarGNF() {
    history.push({
      pathname: '/admin/proposta-gerar-gnf',
      state: { proposta, propostaVersao },
    });
  }

  async function carregarInfoMaterialValido() {
    const valoresResponse = await api.get(
      `/proposta/versao/${propostaVersaoLocation.id}/materiais-valor`,
    );

    const custosResponse = await api.get(
      `/proposta/versao/${propostaVersaoLocation.id}/materiais-custo`,
    );

    const { valoresValidos } = valoresResponse.data;
    const { custosValidos } = custosResponse.data;

    setIsMaterialValid(valoresValidos && custosValidos);
    setTriggerMaterialCheck(false);
  }

  useEffect(() => {
    if (triggerMaterialCheck) {
      carregarInfoMaterialValido();
      carregaPropostaVersao();
    }
  }, [triggerMaterialCheck]);

  useEffect(() => {
    if (acessoProgramaAprovacao) {
      setContemAbaAprovacao(acessoProgramaAprovacao.podeAcessar === true);
    }
  }, [acessoProgramaAprovacao]);

  async function onSavePostback() {
    // O processo de salvar informações deu certo.
    // Como ele dispara apenas na troca para APROVADA, agora preciso disparar manualmente o processo

    await atualizaStatus(STATUS_APROVADO_ID);
    setStatusIdAtual(STATUS_APROVADO_ID);

    carregaPropostaVersao();
  }

  useEffect(() => {
    if (propostaVersao) {
      setMeioPagamentoIdSelecionado(propostaVersao?.meioPagamentoId);
    }
  }, [propostaVersao]);

  async function handleGerarAta() {
    const response = await api.post(`/ata-briefing/gerar-ata`, {
      propostaVersaoId: propostaVersao.id,
    });

    history.push({
      pathname: '/admin/ata-proposta',
      state: {
        proposta,
        propostaVersao,
        meioPagamentos,
        meioPagamentoIdSelecionado,
        propostaConfiguracoes,
        produtoProposta,
      },
    });
  }

  async function handleSaveModalPessoaGrupo(itemSelecionado: string) {
    // await getOrcamentoVersao();

    if (String(propostaCliente.pessoa?.codigoDomsge) !== itemSelecionado) {
      try {
        toast.loading('Salvando...');
        await api.put(`/pessoa/atualizar-pessoa-registro`, {
          propostaId: proposta.id,
          propostaVersaoId: propostaVersao.id,
          pessoaSgeId: itemSelecionado,
        });

        carregaPropostaVersao();
        carregaConfiguracoes();

        toast.dismiss();
        toast.success('Registro atualizado');
      } catch (ex: any) {
        toast.dismiss();
        Swal.fire({
          icon: 'error',
          title: 'Ops!',
          text: ex?.response?.data?.message,
        });
      }
    }
  }

  function getIndex(index: number, opcoes?: { depoisMatriz?: boolean }) {
    let offset = 0;

    if (contemAbaAprovacao) offset += 1;

    if (opcoes?.depoisMatriz && isRegramentoGeral) {
      offset -= 1;
    }

    return index + offset;
  }

  function statusIsEscopoConcluido(status: PropostaStatus) {
    /**
     * Desabilita os status 'gerado' e 'concluído pela engenharia',
     * caso status atual seja 'escopo concluído'
     */
    if (statusIdAtual === ESCOPO_CONCLUIDO_ID) {
      if (status.ordem < ESCOPO_CONCLUIDO_ORDEM) {
        return (
          <option key={status.id} value={status.id} disabled>
            {status.descricao}
          </option>
        );
      }
      return (
        <option
          key={status.id}
          value={status.id}
          disabled={!status.indicPermiteSelecao}
        >
          {status.descricao}
        </option>
      );
    }

    return (
      <option
        key={status.id}
        value={status.id}
        disabled={!status.indicPermiteSelecao}
      >
        {status.descricao}
      </option>
    );
  }

  return (
    <>
      <UserSmallHeader />
      <ModalLog
        nomeChave="proposta_versao_id"
        valorChave={propostaVersao.id}
        titulo="Logs da proposta"
        modalState={modalStatusLogVisivel}
        toggle={() => setModalStatusLogVisivel(false)}
      />

      <CardHeader hidden={gnfBloqueado}>
        <Row>
          <Col md="4" sm="4" xs="12" lg="4">
            <h4 className="mb-0">Proposta {proposta.id}</h4>{' '}
            <small className="mb-0">
              Versão {propostaVersao.versao} | Configurações{' '}
              {queryConfiguracoes
                ?.map((config: PropostaConfiguracao) => config.orcamentoId)
                .join(', ')}
            </small>
          </Col>
          <Col md="3" sm="3" xs="12" lg="4">
            <small className="mb-0">
              <strong>Gnf: </strong>
              {proposta.codigoOportunidadeDomsge}
              <br />
              <span hidden={!propostaCliente.pessoaGnf}>
                <strong>Cadastro Inicial:</strong>{' '}
                {`${propostaCliente.pessoaGnf?.codigoDomsge} - ${propostaCliente.pessoaGnf?.razaoSocial}`}
              </span>
              <br />
              <small
                hidden={
                  (propostaCliente.pessoaGnf?.id ?? 0) ===
                  (propostaCliente.pessoa?.id ?? 0)
                }
              >
                <strong>Definitivo Proposta:</strong>{' '}
                {`${propostaCliente.pessoa?.codigoDomsge} - ${propostaCliente.pessoa?.razaoSocial}`}
              </small>
            </small>
          </Col>
          <Col md="3" sm="3" xs="12" lg="2">
            <div className="d-flex mt-2">
              {atualizandoStatus && (
                <CircularProgress
                  className="mt-2 mr-3"
                  color="inherit"
                  size={18}
                />
              )}
              <Input
                bsSize="sm"
                type="select"
                disabled={atualizandoStatus || bloquearTudo || gnfBloqueado}
                value={statusIdAtual}
                onChange={event =>
                  handleChangeStatusAtual(Number(event.target.value))
                }
              >
                {listaStatus.map(status => statusIsEscopoConcluido(status))}
              </Input>
            </div>
          </Col>
          <Col md="2" sm="2" xs="12" lg="2">
            {acessoLimitadoAta.temAcesso && (
              <div className="mt-2 float-left">
                <Button
                  size="sm"
                  className="float-right"
                  color="warning"
                  outline
                  onClick={handleGerarAta}
                >
                  Ata
                </Button>
              </div>
            )}
            <div className="mt-2 float-right">
              <InputGroup>
                <Tooltip
                  className="ml-1"
                  title={
                    loadingProposta
                      ? 'Aguarde...'
                      : `Alterar cliente da proposta`
                  }
                >
                  <div>
                    <Button
                      size="sm"
                      className="float-right"
                      color="default"
                      outline
                      type="button"
                      hidden={
                        !mostrarBotaoMudarPessoa.temAcesso ||
                        bloquearProposta ||
                        gnfBloqueado
                      }
                      onClick={() => setModalManterPessoaGrupo(true)}
                    >
                      <FaUser />
                    </Button>
                  </div>
                </Tooltip>

                <Tooltip
                  title={loadingProposta ? 'Aguarde...' : 'Geração GNF'}
                  className="ml-1"
                  hidden={
                    statusIdAtual !== STATUS_APROVADO_ID && tipoGerar !== 'PS'
                  }
                >
                  <Button
                    size="sm"
                    className="float-right"
                    color="default"
                    outline
                    disabled={
                      loadingProposta ||
                      atualizandoStatus ||
                      (statusIdAtual !== STATUS_APROVADO_ID &&
                        tipoGerar !== 'PS')
                    }
                    onClick={handleGerarGNF}
                  >
                    Gerar GNF
                  </Button>
                </Tooltip>

                <Tooltip title="Logs" className="ml-1">
                  <Button
                    size="sm"
                    className="float-right"
                    color="default"
                    outline
                    onClick={() => setModalStatusLogVisivel(true)}
                  >
                    <FaHistory />
                  </Button>
                </Tooltip>

                <Tooltip
                  className="ml-1"
                  title={
                    loadingProposta
                      ? 'Aguarde...'
                      : `${
                          loadingProposta || !liberaImpressao
                            ? `Não é possível imprimir a proposta. Abaixo algumas das possíveis causas. Uma ou mais configurações associadas possuem materiais sem valor, a proposta está sem valor, ou os dados básicos de local não informados ou meio de pagamento não está selecionado, ou a validação de materiais encontrou agrupadores obrigatórios sem item em alguma das configurações associadas. Proposta ficará bloqueada até que seja corrigido.`
                            : 'Imprimir proposta'
                        }`
                  }
                >
                  <div>
                    <Button
                      size="sm"
                      className="float-right"
                      color="default"
                      outline
                      onClick={handleImprimeProposta}
                    >
                      <FaPrint />
                    </Button>
                  </div>
                </Tooltip>
              </InputGroup>
            </div>
          </Col>
        </Row>
        <Row>
          <div className="d-flex w-100 justify-content-start align-items-center">
            <div className="d-flex flex-column mx-3 mb-0 mt-4">
              <small>
                <strong>Localização:</strong>{' '}
                {proposta.PropostaLocalObra?.municipio} /{' '}
                {proposta.PropostaLocalObra?.uf}
              </small>

              <small>
                <strong>Usuário:</strong> {proposta.usuario.nome}
              </small>

              {hierarquiaDomSGE?.pessoaCargoDesc ? (
                <small>
                  <strong>Função:</strong> {hierarquiaDomSGE.pessoaCargoDesc}
                </small>
              ) : (
                <small> </small>
              )}
            </div>
            <div className="d-flex flex-column mx-3 mb-0 mt-2">
              {hierarquiaDomSGE?.pessoaRazao ? (
                <small>
                  <strong>Empresa:</strong> {hierarquiaDomSGE.pessoaRazao}
                </small>
              ) : (
                <small> </small>
              )}

              {hierarquiaDomSGE?.pessoaSupRazao ? (
                <small>
                  <strong>Superior:</strong> {hierarquiaDomSGE.pessoaSupRazao} |{' '}
                  {hierarquiaDomSGE.pessoaSupCargoDesc}
                </small>
              ) : (
                <small> </small>
              )}
            </div>
          </div>
        </Row>
      </CardHeader>

      <div style={{ padding: '5px' }} hidden={!gnfBloqueado}>
        <Alert color="warning" className="mt-2 ml-5 mr-5">
          Gnf bloqueado no CRM. As ações no portal foram bloqueadas.{' '}
          {gnfBloqueadoMotivo ?? 'Motivo não informado'}
        </Alert>
      </div>

      {bloquearTudo && (
        <div style={{ padding: '50px' }}>
          <Alert color="warning" className="mt-2 ml-5 mr-5">
            <p>
              Essa proposta possui configurações que você não possui acesso.
            </p>
            <p>
              Solicite acesso a elas:{' '}
              <strong>{configuracoesSemAcesso?.join(',')}</strong>
            </p>
          </Alert>
        </div>
      )}
      {bloquearProposta === true && (
        <>
          <div style={{ padding: '5px' }}>
            <Alert color="warning" className="mt-2 ml-5 mr-5">
              Validação de materiais encontrou agrupadores obrigatórios sem item
              em alguma das configurações associadas. Proposta ficará bloqueada
              até que seja corrigido.
              <br />
              Será necessário aguardar, a equipe de Engenharia já foi notificada
              e estão avaliando.
            </Alert>
          </div>
        </>
      )}

      <AppBar>
        <Tabs
          value={currentTab}
          hidden={bloquearTudo || gnfBloqueado}
          onChange={(_, newCurrentTab) => setCurrentTab(newCurrentTab)}
          indicatorColor="primary"
          textColor="primary"
          variant={isSmallScreen ? 'scrollable' : 'fullWidth'}
          scrollButtons={isSmartphoneScreen ? 'on' : 'auto'}
          TabScrollButtonProps={{
            style: {
              backgroundColor: '#bdbdbd',
            },
          }}
        >
          {contemAbaAprovacao === true && (
            <Tab label="Aprovação" style={{ fontWeight: 600 }} />
          )}
          <Tab label="Obra" style={{ fontWeight: 600 }} />
          {liberaEtapa && (
            <Tab
              label="Materiais"
              style={{
                fontWeight: 600,
              }}
            />
          )}
          {
            // Desativado. Está incluso no precificação
            /* liberaEtapa && liberaAposMaterial && (
            <Tab
              label="Parcelas"
              style={{
                fontWeight: 600,
              }}
            />
          )
          */
          }
          {liberaEtapa && liberaAposMaterial && !isRegramentoGeral && (
            <Tab
              label="Matriz Responsabilidade"
              style={{
                fontWeight: 600,
              }}
            />
          )}
          {liberaEtapa && liberaAposMaterial && (
            <Tab
              label="Precificação"
              style={{
                fontWeight: 600,
              }}
            />
          )}
          {
            // Desativado. Está incluso no precificação
            /* liberaEtapa && liberaAposMaterial && (
            <Tab
              label="Resumo"
              style={{
                fontWeight: 600,
              }}
            />
          )
          */
          }
          {liberaEtapa && liberaAposMaterial && (
            <Tab
              label="Faturamento Direto"
              style={{
                fontWeight: 600,
              }}
            />
          )}
          {liberaEtapa &&
            liberaAposMaterial &&
            acessoProgramaAnalisador.temAcesso === true && (
              <Tab
                label="Analisador"
                style={{
                  fontWeight: 600,
                }}
              />
            )}
        </Tabs>
      </AppBar>

      {mostrarBotaoMudarPessoa.temAcesso && (
        <ModalPessoaGrupo
          pessoaId={propostaCliente.pessoa?.codigoDomsge ?? ''}
          modalState={modalManterPessoaGrupo}
          onSave={handleSaveModalPessoaGrupo}
          toggle={() => setModalManterPessoaGrupo(false)}
        />
      )}

      <div hidden={bloquearTudo || gnfBloqueado}>
        <PropostaContext.Provider
          value={{
            propostaVersao,
            setPropostaVersao,
            propostaLocalObra,
            setPropostaLocalObra,
            permiteModificacao,
            formatoMaoDeObra,
            setFormatoMaoDeObra,
            condicaoFrete,
            setCondicaoFrete,
            carregaPropostaVersao,
            propostaConfiguracoes,
            setPropostaConfiguracoes,
            meioPagamentos,
            meioPagamentoIdSelecionado,
            setMeioPagamentoIdSelecionado,
            acessoLimitado,
            setIsObraExterior,
            isObraExterior,
            setTriggerMaterialCheck,
            isMaterialValid,
            atualizarTelaProposta,
            isIsentoComissao,
            setIsIsentoComissao,
            bloquearLocal,
            setBloquearLocal,
            baixarAta,
            setBaixarAta,
            configuracaoId:
              Number(configuracaoId) ??
              propostaConfiguracoes.find(item => item.orcamentoId),
            setConfiguracaoId,
            setPrecosDesatualizados,
            regramentoProposta,
          }}
        >
          <ModalValoresAprovacao
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            propostaVersaoId={propostaVersao.id}
            onSavePostback={onSavePostback}
          />

          {contemAbaAprovacao === true && (
            <TabPanel value={currentTab} index={0}>
              <Aprovacao propostaVersao={propostaVersao} />
            </TabPanel>
          )}

          <TabPanel
            value={currentTab}
            index={contemAbaAprovacao === true ? 1 : 0}
          >
            <ValoresAprovacao
              propostaVersaoId={propostaVersao.id}
              acessoPrograma={acessoProgramaModificarStatusAprovada}
            />
            <Observacao
              proposta={proposta}
              propostaVersaoId={propostaVersao.id}
            />
            <LocalObra
              proposta={proposta}
              propostaVersaoId={propostaVersao.id}
            />
            <PosicaoGeografica
              proposta={proposta}
              propostaVersaoId={propostaVersao.id}
              produtoProposta={produtoProposta}
            />
            <AvalistaObra />
            {regramentoProposta && tipoGerar === 'PS' && (
              <MaoDeObra
                onMaoDeObraAtualizada={setMaoDeObraAtualizada}
                orcamentoId={Number(configuracaoId)}
                configuracoes={propostaConfiguracoes
                  .map(config => config.orcamentoId)
                  .join(', ')}
              />
            )}
            <ValoresPorConfiguracao
              formatoMaoDeObra={formatoMaoDeObra}
              propostaConfiguracoes={propostaConfiguracoes}
              carregandoPropostaConfiguracoes={carregandoPropostaConfiguracoes}
              setModalCalculoLogVisivel={setModalCalculoLogVisivel}
              setConfiguracaoId={setConfiguracaoId}
              configuracaoId={Number(configuracaoId)}
              acessoLimitado={acessoLimitado}
              acessoLimitadoValorMaoObra={acessoLimitadoValorMaoObra}
            />

            <LogsCalculoServico
              orcamentoId={
                Number(configuracaoId) ??
                propostaConfiguracoes.find(item => item.orcamentoId)
              }
              exibeLogs={modalCalculoLogVisivel}
            />
          </TabPanel>

          <TabPanel
            value={currentTab}
            // index={contemAbaAprovacao === true ? 2 : 1}
            index={getIndex(1)}
          >
            <Materiais />
          </TabPanel>

          {!isRegramentoGeral && (
            <TabPanel
              value={currentTab}
              // index={contemAbaAprovacao === true ? 3 : 2}
              index={getIndex(2)}
            >
              <MatrizResponsabilidade />
            </TabPanel>
          )}

          <TabPanel
            value={currentTab}
            // index={contemAbaAprovacao === true ? 4 : 3}
            index={getIndex(3, { depoisMatriz: true })}
          >
            <Precificacao
              isRegramentoGeral={regramentoProposta === false}
              tipoGerar={tipoGerar}
            />
          </TabPanel>

          {
            // Desativado. Está dentro do precificação
            /*
  <TabPanel
            value={currentTab}
            index={contemAbaAprovacao === true ? 6 : 5}
          >
            <Resumo carregaPropostaVersao={carregaPropostaVersao} />
          </TabPanel>
  */
          }

          <TabPanel
            value={currentTab}
            // index={contemAbaAprovacao === true ? 5 : 4}
            index={getIndex(4, { depoisMatriz: true })}
          >
            <Compras
              propostaVersao={propostaVersao}
              propostaConfiguracoes={propostaConfiguracoes}
              statusIdAtual={statusIdAtual}
              carregaPropostaVersao={carregaPropostaVersao}
            />
          </TabPanel>

          {acessoProgramaAnalisador.temAcesso === true && (
            <TabPanel
              value={currentTab}
              // index={contemAbaAprovacao === true ? 6 : 5}
              index={getIndex(5, { depoisMatriz: true })}
            >
              <Resultados
                propostaVersao={propostaVersao}
                apenasSintetica={false}
              />
            </TabPanel>
          )}
        </PropostaContext.Provider>
      </div>
    </>
  );
}
